import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
export default {
  methods: {
    invertLabelValueMap(labelValueMap) {
      return _reduceInstanceProperty(labelValueMap).call(labelValueMap, (acc, curr) => {
        acc[curr.value] = curr.label;
        return acc;
      }, {});
    }
  }
};